<template lang="html">

 <div class="sala-prensa--view sala-prensa">

   <intro></intro> 


   <section class="pad-sec">
    <div class="container">
      <div class="col-50" v-if="!!data">
        <h3 class="title title-36">{{$t('sala_prensa.clipping.titulo')}}</h3>
        <p>{{$t('sala_prensa.clipping.texto')}}</p>
        <a target="_blank" v-if="!!data.clipping.length > 0" class="btn btn-dark" :href="getServer+data.clipping[0].archivo" download>{{$t('sala_prensa.clipping.boton')}}</a>
      </div>

      <div class="block-layout">
        <h3 class="title title-26">{{$t('sala_prensa.clipping.logotipo')}}</h3>
        <div class="flex row wrap justify-start">
          <pressroom-el v-for="(e, key) in data.logotipos" :key="key" :data="e"></pressroom-el>
        </div>
      </div>
      <div class="block-layout">
        <h3 class="title title-26">{{$t('sala_prensa.clipping.imagenes')}}</h3>
        <div class="flex row wrap justify-start">
          <pressroom-el v-for="(e, key) in data.imagenes" :key="key" :data="e"></pressroom-el>
        </div>
      </div>
    </div>
  </section>

  <section class="sobre-ajusa sec-foto blue pad-sec">
    <div class="container waypoints flex row-reserve justify-start" data="fadeInLeft">
      <div class="col-50">
        <router-link :to="$t('enlaces.ajusa')"></router-link>
        <h4>{{$t('sala_prensa.ajusa.intro')}}</h4>
        <h3 class="title title-52">{{$t('sala_prensa.ajusa.titulo')}}</h3>
        <p>{{$t('sala_prensa.ajusa.texto')}}</p>
      </div>
    </div>
  </section>

  <otras-secciones :data="['donde_estamos','catalogo']"></otras-secciones>

</div>

</template>

<script lang="js">

  import Otras_Secciones from '@/components/parts/acceso-a-secciones';

  import Intro from '@/components/view-parts/intros/sala-prensa'

  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'

  Vue.use(VueAxios, axios);

  import { mapGetters } from 'vuex'

  import pressroom_el from '@/components/parts/pressroom-el';
  import paginador from '@/components/parts/paginador';


  export default  {
    name: 'sala-prensa',
    props: [],
    mounted() {
      this.getData();
    },
    data() {
      return {
        data : ''
      }
    },
    computed: {
      ...mapGetters(['getServer', 'getLanguage']),
    },
    methods : {
      getData : function(){
        axios.get(`pressroom?lang=${this.getLanguage}`)
        .then(response => {
          this.data = response.data;
        })
        .catch(error => console.log(error));  
      }
    },
    watch : {
      'getLanguage' : function(){
        this.getData();
      }
    },
    components: {
      'otras-secciones' : Otras_Secciones,
      'intro' : Intro,
      'pressroom-el' : pressroom_el,
      'paginador' : paginador
    }
  }
</script>

<style scoped>
.sala-prensa {

}
</style>



// WEBPACK FOOTER //
// src/components/views/sala-prensa.vue